const CONSENT_KEY = 'cookie_consent';

export const getConsent = () => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    try {
        return JSON.parse(stored);
    } catch (e) {
        return null;
    }
};

export const setConsent = (preferences) => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(preferences));

    // Trigger a custom event so the UI can respond
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: preferences }));
};

export const hasUserDecided = () => {
    return localStorage.getItem(CONSENT_KEY) !== null;
};

export const isCategoryAllowed = (category) => {
    const consent = getConsent();
    if (!consent) return false;

    // Essential is always allowed
    if (category === 'essential') return true;

    return consent[category] === true;
};

export const DEFAULT_PREFERENCES = {
    essential: true,
    analytics: false,
    marketing: false
};
